module.exports = __webpack_public_path__ + "img/fifth_cloud_middle.0d4df661.png";